import { useQuery } from 'react-query';
import { mailSettingsApi } from '../services/api';
import { MailSettings } from '../types/mailSettings';

export const MAIL_SETTINGS_QUERY_KEY = 'mailSettings';

export const useMailSettingsQuery = (companyId?: number) =>
  useQuery<MailSettings>(
    [MAIL_SETTINGS_QUERY_KEY, companyId],
    () => mailSettingsApi.getSettings(),
    {
      enabled: !!companyId,
    }
  );
